import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { customFieldEndpoints } from '@/lib/api/endpoints';
import { customFieldKeys } from '@/lib/queryKeys';
import type { CustomFieldValue, CustomFieldEntityType } from '@/types/custom-fields';

export function useCustomFieldValues(entityType: CustomFieldEntityType, entityId: string) {
  return useApiQuery<CustomFieldValue[]>({
    // NOT-369 — JOB values are scoped server-side by the job's Job Type
    // (resolved from `entityId`), so there's no job-type query param or key
    // segment: one values query per entity, matching `useUpsertValues`
    // invalidation.
    queryKey: customFieldKeys.values(entityType, entityId),
    queryFn: () =>
      apiGet<CustomFieldValue[]>(operationsClient, customFieldEndpoints.values(), {
        params: { entityType, entityId },
      }),
    enabled: !!entityType && !!entityId,
  });
}
